import React from 'react';
import styled from 'styled-components';
import { colors } from 'sama_global/theme';
import { PreRunComponent } from '@/pages/olimpic/PreRun';

const Styler = styled.div`
  display: inline-block;
  & > div {
    background-color: transparent;
  }

  .MuiSvgIcon-root {
    fill: ${colors.light};
  }
  .Mui-checked .MuiSvgIcon-root {
    fill: ${colors.purple};
  }

  h3 {
    color: ${colors.purple};
  }

  button.MuiButtonBase-root {
    border-radius: 4px !important;
    background-color: ${colors.purple} !important;
    color: ${colors.light} !important;
  }

  button.MuiButtonBase-root[disabled] {
    background-color: ${colors.pale} !important;
    color: ${colors.light} !important;
    div {
      img {
        filter: grayscale(1) contrast(10) invert(0.65);
      }
      color: ${colors.light};
    }
  }
`;

function StyledPreRun() {
  return (
    <Styler>
      <PreRunComponent />
    </Styler>
  );
}

export default StyledPreRun;
